import { useEffect, useState } from "react";
import { useQueryString } from "hooks/useQueryString";
import { useCampaignContext } from "context/campaignContext";
import { PromoCampaign } from "providers/CampaignProvider";

import Link from "components/Link";
import { isClientFromMedicare } from "components/PromoCampaigns/utils/isClientFromMedicare";
import { getPromoContentComponent } from "components/PromoCampaigns/promoContent/getPromoContentComponent";

import { PriceBannerProps } from "./PriceBanner.types";

export const PriceBanner = ({
    campaign: campaignFromProps,
}: PriceBannerProps) => {
    const { campaign: campaignFromContext } = useCampaignContext();
    const queryString = useQueryString();

    const [campaignData, setCampaignData] = useState<PromoCampaign | null>(
        campaignFromProps || campaignFromContext
    );

    useEffect(() => {
        setCampaignData(campaignFromContext);
    }, [campaignFromContext]);

    if (!campaignData) return <></>;

    const { content, title, theme, campaignLink } = campaignData;

    const linkWithQueryString = queryString
        ? campaignLink + queryString
        : campaignLink;
    const fromMedicare = isClientFromMedicare();
    const isBannerVisible = campaignData && !fromMedicare;

    const contentComponentImport = getPromoContentComponent(
        content,
        "priceBanner"
    );
    const ContentComponent = contentComponentImport?.() ?? null;

    return (
        <>
            {isBannerVisible && (
                <Link
                    cursor="pointer"
                    {...(campaignLink ? { href: linkWithQueryString } : null)}
                >
                    {ContentComponent && (
                        <ContentComponent
                            {...campaignData.content}
                            theme={theme}
                            title={title}
                        />
                    )}
                </Link>
            )}
        </>
    );
};
